export const CRASH_GAME = '/crash-game'
export const PLINKO_GAME = '/plinko-game'
export const WALLET = '/wallet'
export const SYSTEM = '/system'
